import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router';
import { EtapaRevision, Revisiones, TipoRevision } from 'src/app/types/type';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { PlaneacionService } from 'src/app/services/planeacion.service';
import { SeguimientoService } from 'src/app/services/seguimiento.service';
import { Negocios, RevisionesFiltroDTO } from 'src/app/types/Entitys';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { identifierName } from '@angular/compiler';
declare var $: any;

@Component({
  selector: 'app-cartera-revisiones',
  templateUrl: './cartera-revisiones.component.html',
  styleUrls: ['./cartera-revisiones.component.css']
})
export class CarteraRevisionesComponent {
  url: string;
  subMenus: object[];
  title: string;
  revisiones: Revisiones[];
  filtro: RevisionesFiltroDTO;
  tipoRevisiones: TipoRevision[];
  etapas: EtapaRevision[];
  usuarioSesion: any;
  negocioUsuario: number;
  page: number = 2;
  loadRows: boolean = false;
  disableBtnFiltros: boolean = true;
  collectionFiltro: boolean = false;
  IdEmpleado: number;

  constructor(
    private http: HttpClient,
    private router: Router,
    private revisionServicio: PlaneacionService,
    private seguimientoServicio: SeguimientoService,
    private userService: UsuariosService
  ) {
    this.usuarioSesion = {};
    this.filtro = {
      Negocio_Id: 0,
      IdRegion: 0,
      IdEstacion: 0,
      IdEtapa: 0,
      IdTipoRevision: 0,
      FechaInicioPlan: '',
      FechaFinPlan: '',
      FechaInicioReal: '',
      FechaFinReal: ''
    };
  }

  async ngOnInit() {
    this.loadSubMenu();
    const { IdEmpleado, IdNegocio } = await this.userService.getUsuario();    
    this.IdEmpleado = IdEmpleado;
    this.negocioUsuario = IdNegocio;
    this.revisionServicio.getRevisiones(this.IdEmpleado)
      .subscribe(response => {
        this.revisiones = response.Result.Data as Revisiones[]
      });
    this.seguimientoServicio.loadInit()
      .subscribe(([tipoRevisiones, etapas, negocios]) => {
        if (tipoRevisiones.Result.Exito && etapas.Result.Exito && negocios.Result.Exito) {
          this.tipoRevisiones = tipoRevisiones.Result.Data as TipoRevision[]
          this.etapas = etapas.Result.Data as EtapaRevision[]          
        }
        MasterDB.getUsuarioSesion(new EstacionesTVADB())
          .then(usuario => {
            this.usuarioSesion = usuario
          });

        this.disableBtnFiltros = false;
      });
  }

  async Downloadinforme(idRevision) {
    var file: any = await Utilerias.httpRequest(this.http, 'DownloadInformeFinal', 'post', { idRevision: idRevision });
    Utilerias.downloadFile(file.NombreArchivo, file.Contenido)
    Utilerias.showLoader(false);
  }

  checklistClick(idRevision) {
    this.router.navigate(['Seguimiento/ChecklistValidacion', idRevision]);
  };  

  export() {
    let post = {
      filtro: this.filtro
    };
    Utilerias.httpRequest(this.http, 'GetReporteRevisionesFiltro', 'post', post)
      .then((res: any) => {
        Utilerias.showLoader(false);
        Utilerias.downloadFile(res.Nombre, res.Contenido);
      });
  }

  datetimeToDateFormat(input, withTime = false) {
    return Utilerias.datetimeToDateFormat(input, withTime);
  }

  searchRevisionChild(event: RevisionesFiltroDTO) {
    this.loadRows = true;
    this.revisiones = [];    
    this.seguimientoServicio.getRevisionesFiltro(event, this.IdEmpleado)
      .subscribe(response => {
        if (response.Result.Exito) {
          this.revisiones = response.Result.Data as Revisiones[];
          this.collectionFiltro = true;
          this.loadRows = false;
        }
      })
  }

  loadSubMenu() {
    var items = [
      {
        active: true,
        child: false,
        label: 'Cartera de revisiones',
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }

  loadCarteraRevisiones() {
    if (!this.collectionFiltro) {
      this.loadRows = true;
      this.revisionServicio.getRevisiones(this.IdEmpleado, this.page++)
        .subscribe(response => {
          if (response.Result.Exito) {
            const revisiones = response.Result.Data as Revisiones[]
            this.revisiones = [...this.revisiones, ...revisiones]
            this.loadRows = false;
            if (revisiones.length === 0)
              this.page--
          }
        });
    }
  }
}
